import { maxNameLength } from "src/common/rxName";
import { zSidLabel } from "src/types";
import z from "zod";

import { zExtensionFormBinding } from "../extensionBindings/ZExtensionBinding";

export const zWorkflowAttr = z.object({
  specId: z.string(),
  attrId: z.string(),
});
export type ZWorkflowAttr = z.infer<typeof zWorkflowAttr>;

export const zWorkflowStepType = z.enum(["user", "system"]);
export type ZWorkflowStepType = z.infer<typeof zWorkflowStepType>;

export const zSystemStepName = z.enum(["INITIAL", "SUCCESS", "FAILURE"]);
export type ZSystemStepName = z.infer<typeof zSystemStepName>;

const zWorkflowStepBase = z.object({
  id: z.string(),
  displayId: z.number().nullish(),
  name: z.string().max(maxNameLength),
  displayName: z.string().max(maxNameLength).nullish(),
  description: z.string().nullish(),
  predecessors: zSidLabel
    .array()
    .nullish()
    .describe("Предшественники. label - системное название шага"),
  lastStep: z
    .boolean()
    .optional()
    .describe("Вычисляется бэкендом при чтении, при сохранении игнорируется"),
  extensions: zExtensionFormBinding
    .array()
    .nullish()
    .describe(
      "Расширения по событиям. id привязки не храним: при сохранении бэкенд заменяет привязки шага целиком",
    ),
});

export const zUserWorkflowStep = zWorkflowStepBase.extend({
  type: z.literal(zWorkflowStepType.enum.user),
  roles: zSidLabel.array().describe("Исполнители"),
  attributes: zWorkflowAttr
    .array()
    .nullish()
    .describe(
      "конфигурация атрибутов шага, используемая бэкендом для формирования схем",
    ),
});
export type ZUserWorkflowStep = z.infer<typeof zUserWorkflowStep>;

/**
 * Системные шаги создаются бэкендом вместе с РП, у них нет исполнителей и атрибутов.
 * name не ограничен zSystemStepName: новый системный шаг на бэке
 * не должен ломать разбор всего РП
 */
export const zSystemWorkflowStep = zWorkflowStepBase.extend({
  type: z.literal(zWorkflowStepType.enum.system),
});
export type ZSystemWorkflowStep = z.infer<typeof zSystemWorkflowStep>;

export const zWorkflowStep = z.discriminatedUnion("type", [
  zUserWorkflowStep,
  zSystemWorkflowStep,
]);

export type ZWorkflowStep = z.infer<typeof zWorkflowStep>;
